import { useContext, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from 'src/context/AuthContext';
import { autoAppyUrl } from 'src/config/autoAppyUrls';

export default function AutoAppyLogin() {
  const { auth, loading, beginLogin, authError } = useContext(AuthContext);
  const location = useLocation();
  const callbackError = new URLSearchParams(location.search).get('reason');
  const error = authError || callbackError;

  useEffect(() => {
    if (!loading && !auth && !error) beginLogin('/dashboard');
  }, [auth, beginLogin, error, loading]);

  if (auth) return <Navigate to="/dashboard" replace />;
  if (error) return <div className="p-8">AutoAppy authentication could not be completed ({error.replaceAll('_', ' ')}). <a className="text-sky-700 underline" href={autoAppyUrl('/')}>Return to AutoAppy</a>.</div>;
  return <div className="p-8">Connecting to AutoAppy…</div>;
}
